import clsx from 'clsx';
import { ReactNode } from 'react';
import Paper, { PaperProps } from './Paper';
import classes from './Widget.module.scss';

export default function Widget({
  surface = 'white',
  children,
  className,
  title,
  ...rest
}: WidgetProps) {
  return (
    <Paper className={clsx(classes.root, classes[surface])} {...rest}>
      {Boolean(title) && <WidgetHeader title={title} />}
      <div className={clsx(classes.children, className)}>{children}</div>
    </Paper>
  );
}

export function WidgetHeader({
  title,
  children,
}: {
  children?: ReactNode;
  title?: ReactNode;
}) {
  return (
    <div className={classes.header}>
      <div className={classes.title}>{title}</div>
      <div className={classes.toolbar}>{children}</div>
    </div>
  );
}

export function WidgetFooter({ children }: { children: ReactNode }) {
  return <div className={classes.footer}>{children}</div>;
}

export interface WidgetProps extends PaperProps {
  surface?: 'gray' | 'white';
  title?: string;
}
